"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
var amy_1 = require("./amy");
var april_1 = require("./april");
var carmen_1 = require("./carmen");
var carol_1 = require("./carol");
var dharma_1 = require("./dharma");
var hertha_1 = require("./hertha");
var iris_1 = require("./iris");
var medusa_1 = require("./medusa");
var vivien_1 = require("./vivien");
var stage = 'test';
if (typeof process !== 'undefined' && process.env.STAGE === 'prod') {
    stage = 'prod';
}
exports.april = new april_1.default(stage);
exports.carol = new carol_1.default(stage);
exports.hertha = new hertha_1.default(stage);
exports.iris = new iris_1.default(stage);
exports.medusa = new medusa_1.default(stage);
exports.amy = new amy_1.default(stage);
exports.carmen = new carmen_1.default(stage);
exports.vivien = new vivien_1.default(stage);
exports.dharma = new dharma_1.default(stage);
var preset_1 = require("./helper/preset");
exports.preset = preset_1.preset;
// export types
__export(require("pkg-cruise-api-types"));
//# sourceMappingURL=index.js.map